import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'andamentoTipo'
})
export class AndamentoTipoPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let valorFormatado = "";
    if(value == 'Abrir'){
      valorFormatado = "Aberta";
    }else if(value == 'Atender'){
      valorFormatado = "Atendida";
    }else if(value == 'No local'){
      valorFormatado = "No local";
    }else if(value == 'Não Atender'){
      valorFormatado = "Não Atendida";
    }else if(value == 'Despachar'){
      valorFormatado = "Despachada";
    }else if(value == 'Reinterar'){
      valorFormatado = "Reinterada";
    }else if(value == 'Cancelar'){
      valorFormatado = "Cancelada";
    }else if(value == 'Fechar'){
      valorFormatado = "Fechada";
    }else if(value == 'Fechar Não Atender'){
      valorFormatado = "Fechada";
    }else if(value == 'Devolver'){
      valorFormatado = "Devolvido";
    }else if(value == 'Reclassificar'){
      valorFormatado = "Reclassificada";
    }else{
      valorFormatado = "Aceita";
    }
    return valorFormatado;
  }

}


// WEBPACK FOOTER //
// ./src/app/pipes/andamento-tipo.pipe.ts